import ko from "knockout";
import _ from "lodash";
import ObservableModel from "util/ObservableModel";
import VisibilityConditionOperation from "enums/composer/VisibilityConditionOperation";

export default ObservableModel.extend(
    {
        defaults: {
            combiningOperation: VisibilityConditionOperation.AND,
            predicates: [],
        },
    },
    function visibilityConditionModel_init() {
        const self = this;

        self.predicates(_.uniq(self.predicates()));

        self.addPredicate = function (predicatePath) {
            self.predicates.push(predicatePath || "");
        };

        self.removePredicate = function (predicatePath) {
            // TODO: Broken
            self.predicates.remove(predicatePath);
        };

        if (self.predicates().length === 0) {
            self.addPredicate();
        }

        // Add Knockout-Validation functionality.
        ko.validation.group(self, { deep: true, live: true });
        self.combiningOperation.extend({ required: true });

        // Add an unwrap function to remove all unnecessary properties.
        // toIgnore - {object} OR {array}
        //   {object} - An object that maps which properties to ignore based on the type of the model.
        //     The toIgnore key pertaining to this model would be;
        //       'questionGroup': ['properties', 'to', 'ignore']
        //   OR {array} an array of properties to ignore:
        //       ['properties', 'to', 'ignore']
        self.unwrap = function (toIgnore) {
            toIgnore = toIgnore || {};
            const typeName = "visibilityCondition";
            let ignore = ["addPredicate", "removePredicate", "errors"];
            if (toIgnore instanceof Array) {
                // if toIgnore is an array
                ignore = ignore.concat(toIgnore || []);
            } else {
                // if toIgnore is an object mapping
                ignore = ignore.concat(toIgnore[typeName] || []);
            }
            const data = ObservableModel.unwrap(self, ignore);
            data.predicates = _.map(self.predicates(), function (submodel) {
                return ko.unwrap(submodel);
            });
            return data;
        };
    }
);
